var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import Icon from "../Icon";
var Svg = styled(Icon)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
export var ScanLogo = function (_a) {
    var _b = _a.color, color = _b === void 0 ? "#E2665C" : _b, _c = _a.width, width = _c === void 0 ? 18 : _c, _d = _a.height, height = _d === void 0 ? 37 : _d, className = _a.className;
    return (React.createElement("div", { style: { width: width, height: height }, className: className },
        React.createElement(Svg, { viewBox: "0 0 18 37" },
            React.createElement("path", { d: "M17.5716 8.26514L0.428711 16.6306V8.45969L17.5716 0.142883V8.26514Z", fill: color }),
            React.createElement("path", { d: "M17.5716 18.2842L0.428711 26.6011V18.4788L17.5716 10.162V18.2842Z", fill: color }),
            React.createElement("path", { d: "M0.428711 36.5715V28.4492L8.97572 24.2665L0.428711 36.5715Z", fill: color }))));
};
var templateObject_1;
